import { createFileRoute } from "@tanstack/react-router";
import { AdminOverview } from "@/pages/Admin/AdminOverview";

export const Route = createFileRoute("/admin/")({
  component: AdminOverview,
});
